import { Palette } from 'config';
import styled from '@emotion/styled';

export const DialogFooterSection = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 24px;
  background-color: ${Palette.PrimaryGray._000};
  box-sizing: border-box;
`;
export const DialogFooterButtons = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0px;
  border-width: 0px;
  box-sizing: content-box;
  background: none;
`;
